import NiceModal, { useModal } from '@ebay/nice-modal-react'
import { CogIcon, TrashIcon } from '@heroicons/react/24/outline'
import { Button, Card } from 'components/gsys-ui'
import { useState } from 'react'
import ModalContainer from 'components/ModalContainer'
import { clearAllAddressOverrides, getAddressOverrides } from 'util/deliveryAddressOverrides'

const DeliveryAddressSettingsModal = NiceModal.create(() => {
    const modal = useModal()
    const [message, setMessage] = useState('')

    // Get the count of overrides
    const overrides = getAddressOverrides()
    const overrideCount = Object.keys(overrides).length

    const handleClearAll = () => {
        const success = clearAllAddressOverrides()
        if (success) {
            setMessage('All delivery address overrides have been cleared')
        } else {
            setMessage('Error clearing delivery address overrides')
        }
    }

    return (
        <ModalContainer>
            <Card className="!w-[500px]">
                <Card.Title Icon={CogIcon}>
                    Delivery Address Settings
                </Card.Title>
                <Card.Body>
                    <div className="mb-6">
                        <h3 className="text-lg font-medium mb-2">Delivery Address Overrides</h3>
                        <p className="text-gray-600 mb-4">
                            You currently have {overrideCount} saved delivery address {overrideCount === 1 ? 'override' : 'overrides'}.
                        </p>

                        {overrideCount > 0 && (
                            <Button
                                variant="danger"
                                Icon={TrashIcon}
                                onClick={handleClearAll}
                                className="mt-2"
                            >
                                Clear All Overrides
                            </Button>
                        )}
                    </div>

                    {message && (
                        <div className="p-3 bg-gray-100 rounded-md mb-4">
                            {message}
                        </div>
                    )}

                    <div className="flex justify-end">
                        <Button variant="white" onClick={modal.remove}>Close</Button>
                    </div>
                </Card.Body>
            </Card>
        </ModalContainer>
    )
})

export default DeliveryAddressSettingsModal